module.exports = __webpack_public_path__ + "img/icon-master-card.9903bcf9.svg";